export default "__VITE_ASSET__c0ff74e4__"